export { DepartmentAvailabilityScreen } from "./DepartmentAvailabilityScreen";
